import script from "./SellerList.vue?vue&type=script&setup=true&lang=js"
export * from "./SellerList.vue?vue&type=script&setup=true&lang=js"

import "./SellerList.vue?vue&type=style&index=0&id=03f889a6&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-03f889a6"]])

export default __exports__